// extracted by mini-css-extract-plugin
export default {"container":"OverviewLegendItem_container__zbhrP"};